import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatMoneyInput } from "@/lib/formatters";

type MoneyFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (raw: string) => void;
  required?: boolean;
};

export function MoneyField({ id, label, value, onChange, required }: MoneyFieldProps) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
      <div className="relative">
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-500">
          ₦
        </span>
        <Input
          id={id}
          inputMode="decimal"
          autoComplete="off"
          className="pl-8"
          value={formatMoneyInput(value)}
          onChange={(event) => onChange(parseMoneyDraft(event.target.value))}
          placeholder="0.00"
        />
      </div>
    </div>
  );
}

function parseMoneyDraft(value: string): string {
  const cleaned = value.replace(/,/g, "").replace(/[^\d.]/g, "");
  const dot = cleaned.indexOf(".");
  if (dot === -1) return cleaned;
  const fraction = cleaned
    .slice(dot + 1)
    .replace(/\./g, "")
    .slice(0, 2);
  return `${cleaned.slice(0, dot)}.${fraction}`;
}
